{
  "94ea9b1d33a02975": "Show less",
  "a58558effdc5d28c": "This will be shown to professionals before they book this shift.",
  "b7c0d007120b9767": "Edit shift note",
  "e7ca563e7ef6c518": "Shift note",
  "f5c9bd131486e793": "Show more"
}
